import { Payload } from '../../router.js';

export const IFrameAnalyticsEvent = 'iframe-analytics-event';
export interface IFrameAnalyticsEventPayload {
  event: string;
  payload: Payload<unknown>;
}
